import React, { type ReactNode } from 'react';

interface WrapperProps {
  id?: string;
  classStyle?: string;
  children?: ReactNode;
}

const Wrapper = ({ id, classStyle, children }: WrapperProps) => {
  return (
    <section
      id={id}
      className={`w-full lg:px-[100px] md:px-[20px] sm:px-[20px] xs:px-[20px] lg:mt-[100px] md:mt-[100px] sm:mt-[20px] xs:mt-[30px] flex flex-col justify-center ${classStyle ?? ''}`}
    >
      {children}
    </section>
  );
};

export default Wrapper;
